import styled from "@emotion/styled";
import TableRow from "@mui/material/TableRow";
import { COLOR_GREY_6 } from "shared/theme/colors";

export const StyledTileRow = styled(TableRow)<{
  shiftHeight?: number;
  index: number;
  isDragging?: boolean;
}>`
  cursor: pointer;
  width: 100%;
  transform: translateY(0) translateZ(0);
  position: relative;
  will-change: transform;
  isolation: isolate;
  -webkit-font-smoothing: antialiased;
  transform-style: preserve-3d;
  backface-visibility: hidden;

  &.entering {
    opacity: 0;
    animation: fadeIn 0.8s ease-out 0.8s forwards;
    position: relative;
    z-index: 2;
  }

  &.shifting {
    opacity: 0;
    animation: shiftDown 0.8s ease-out forwards;
    position: relative;
    z-index: 2;
  }

  &[style*="transform: translate"] {
    ${({ isDragging }) =>
      isDragging
        ? `
      transform-style: preserve-3d;
      will-change: transform;
      td:last-child {
        width: 100%;
      }
    `
        : `
      transition: none !important;
    `}
  }

  &:hover {
    background-color: ${COLOR_GREY_6};
  }

  @keyframes shiftDown {
    from {
      opacity: 0;
      transform: translateY(
        -${(props) => (props.shiftHeight ? `${props.shiftHeight}px` : "40px")}
      );
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
